import React, { type ReactNode } from 'react'
import { Navigation } from './Navigation'
import { Breadcrumbs } from './Breadcrumbs'

interface LayoutProps {
  children: ReactNode
  showBreadcrumbs?: boolean
}

/**
 * Main layout component that wraps all authenticated pages
 * Provides consistent navigation header and optional breadcrumbs
 */
export const Layout: React.FC<LayoutProps> = ({
  children,
  showBreadcrumbs = true,
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-secondary-50 via-white to-primary-50">
      <Navigation />
      <main className="max-w-7xl mx-auto px-6 py-8">
        {showBreadcrumbs && <Breadcrumbs />}
        {children}
      </main>
    </div>
  )
}
